/* Zillabeau predictive search (Sean 2026-09-29, QA: live Stiletto had a quick-search drawer; the new theme needed Enter).
   - Header "Search" opens a search bar under the header with live results while typing.
   - Every other search box that submits to /search (search page, home "Find the exact gel") gets the same dropdown.
   Data: Shopify /search/suggest.json (products, collections, suggested queries). Enter / "See all results" -> /search?q=. */
(function () {
  if (window.zbmPredictive) return;
  window.zbmPredictive = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  // discontinued brands / hidden brand collections never appear as suggested collections
  var HIDE = /(candy\s*\+|cakegel|fiote|inity|lily\s*gel|lilygel|\btiny\b|1st street|first street|lucanus|tsumekira)/i;
  var css = '' +
    '.zbm-ps{position:absolute;left:0;right:0;top:100%;z-index:60;background:var(--color-bg,#f3f2f2);border:2px solid var(--color-divider,#201e1d);border-top:0;max-height:min(70vh,36rem);overflow:auto;text-align:left;font-family:var(--font-body,inherit)}' +
    '.zbm-ps[hidden]{display:none}' +
    '.zbm-ps-sec{padding:12px 16px}.zbm-ps-sec+.zbm-ps-sec{border-top:1px solid var(--color-neutral-300,#d6d3d1)}' +
    '.zbm-ps-h{font-family:var(--font-heading,inherit);font-weight:800;font-size:.6875rem;letter-spacing:.1em;text-transform:uppercase;color:var(--color-neutral-800,#44403c);margin:0 0 8px}' +
    '.zbm-ps-p{display:grid;grid-template-columns:48px 1fr auto;gap:12px;align-items:center;padding:6px 0;color:var(--color-text,#201e1d);text-decoration:none}' +
    '.zbm-ps-p img,.zbm-ps-p .zbm-ps-noimg{width:48px;height:48px;object-fit:cover;background:#fff;border:1px solid var(--color-neutral-300,#d6d3d1)}' +
    '.zbm-ps-p b{display:block;font-weight:700;font-size:.875rem;line-height:1.3}.zbm-ps-p small{display:block;font-size:.6875rem;letter-spacing:.06em;text-transform:uppercase;color:var(--color-neutral-800,#44403c)}' +
    '.zbm-ps-pr{font-weight:800;font-size:.875rem;white-space:nowrap;text-align:right}.zbm-ps-pr s{display:block;font-weight:400;font-size:.75rem;color:var(--color-neutral-800,#44403c)}' +
    '.zbm-ps-p.is-out{opacity:.5}.zbm-ps-so{display:block;font-size:.625rem;font-weight:800;letter-spacing:.08em;text-transform:uppercase}' +
    '.zbm-ps-chips{display:flex;flex-wrap:wrap;gap:6px}.zbm-ps-chip{display:inline-block;padding:5px 10px;border:1px solid var(--color-divider,#201e1d);font-size:.8125rem;color:var(--color-text,#201e1d);text-decoration:none}' +
    '.zbm-ps-p:hover b,.zbm-ps-p.is-active b,.zbm-ps-chip:hover,.zbm-ps-chip.is-active{color:var(--color-accent,#ec3013)}.zbm-ps-chip.is-active{border-color:var(--color-accent,#ec3013)}' +
    '.zbm-ps-all{display:block;padding:12px 16px;border-top:2px solid var(--color-divider,#201e1d);font-family:var(--font-heading,inherit);font-weight:800;font-size:.875rem;color:var(--color-accent-700,#b3240e);text-decoration:none}' +
    '.zbm-ps-empty{padding:16px;font-size:.875rem;color:var(--color-neutral-800,#44403c)}' +
    '.zbm-psbar{position:absolute;left:0;right:0;top:100%;z-index:59;background:var(--color-bg,#f3f2f2);border-bottom:2px solid var(--color-divider,#201e1d);padding:12px 0}' +
    '.zbm-psbar[hidden]{display:none}' +
    '.zbm-psbar-in{position:relative;display:flex;gap:8px;max-width:48rem;margin:0 auto;padding:0 16px}' +
    '.zbm-psbar input{flex:1;min-width:0;font:inherit;font-size:16px;padding:12px 14px;border:2px solid var(--color-divider,#201e1d);border-radius:0;background:#fff;color:var(--color-text,#201e1d)}' +
    '.zbm-psbar button{font-family:var(--font-heading,inherit);font-weight:800;font-size:.875rem;border:0;border-radius:0;padding:0 18px;cursor:pointer}' +
    '.zbm-psbar .zbm-psbar-go{background:var(--color-accent,#ec3013);color:#fff}.zbm-psbar .zbm-psbar-x{background:transparent;color:var(--color-text,#201e1d);text-decoration:underline}' +
    '.zbm-psbar .zbm-ps{left:16px;right:16px}' +
    '.zbm-ps-wrap{position:relative}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(v) { var n = parseFloat(v); return isNaN(n) ? '' : '$' + n.toFixed(2); }
  function sized(src, w) { if (!src) return ''; return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; }
  function searchUrl(q) { return root + 'search?q=' + encodeURIComponent(q); }

  var cache = {};
  function fetchSuggest(q) {
    if (cache[q]) return Promise.resolve(cache[q]);
    var qs = 'q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=8&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';
    return fetch(root + 'search/suggest.json?' + qs, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { var res = (j && j.resources && j.resources.results) || {}; cache[q] = res; return res; });
  }

  function render(box, q, res) {
    var prods = (res.products || []).filter(function (p) { return !(p.tags && p.tags.indexOf && p.tags.indexOf('hidden') !== -1); });
    var cols = (res.collections || []).filter(function (c) { return !HIDE.test(c.title || '') && !HIDE.test(c.handle || ''); });
    var qs = (res.queries || []).filter(function (x) { return x.text && x.text.toLowerCase() !== q.toLowerCase(); }).slice(0, 5);
    var h = '';
    if (qs.length) {
      h += '<div class="zbm-ps-sec"><p class="zbm-ps-h">Suggestions</p><div class="zbm-ps-chips">' +
        qs.map(function (x) { return '<a class="zbm-ps-chip" data-ps-item href="' + esc(searchUrl(x.text)) + '">' + esc(x.text) + '</a>'; }).join('') + '</div></div>';
    }
    if (prods.length) {
      h += '<div class="zbm-ps-sec"><p class="zbm-ps-h">Products</p>' + prods.map(function (p) {
        var img = p.image || (p.featured_image && p.featured_image.url) || '';
        // legal 2026-10-08: struck price only from the variant whose price is shown, and only when its compare-at > price
        var was = '', pp = parseFloat(p.price);
        if (!p.gift_card && p.handle !== 'zillaplus') {
          (p.variants || []).some(function (v) {
            var vp = parseFloat(v.price), vc = parseFloat(v.compare_at_price);
            if (vp === pp && vc > vp) { was = '<s>' + money(v.compare_at_price) + '</s>'; return true; }
            return false;
          });
        }
        return '<a class="zbm-ps-p' + (p.available === false ? ' is-out' : '') + '" data-ps-item href="' + esc(p.url) + '">' +
          (img ? '<img src="' + esc(sized(img, 120)) + '" alt="" loading="lazy" width="48" height="48">' : '<span class="zbm-ps-noimg"></span>') +
          '<span>' + (p.vendor ? '<small>' + esc(p.vendor) + '</small>' : '') + '<b>' + esc(p.title) + '</b>' +
          (p.available === false ? '<span class="zbm-ps-so">Sold out</span>' : '') + '</span>' +
          '<span class="zbm-ps-pr">' + money(p.price) + was + '</span></a>';
      }).join('') + '</div>';
    }
    if (cols.length) {
      h += '<div class="zbm-ps-sec"><p class="zbm-ps-h">Collections</p><div class="zbm-ps-chips">' +
        cols.map(function (c) { return '<a class="zbm-ps-chip" data-ps-item href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') + '</div></div>';
    }
    if (!h) h = '<p class="zbm-ps-empty">No matches for “' + esc(q) + '” yet. Try a color number, brand or product type.</p>';
    h += '<a class="zbm-ps-all" data-ps-item href="' + esc(searchUrl(q)) + '">See all results for “' + esc(q) + '” &rarr;</a>';
    box.innerHTML = h;
    box.hidden = false;
  }

  function attach(input) {
    if (!input || input.getAttribute('data-ps-on')) return;
    input.setAttribute('data-ps-on', '1');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    var host = input.parentNode;
    if (getComputedStyle(host).position === 'static') host.classList.add('zbm-ps-wrap');
    var box = document.createElement('div');
    box.className = 'zbm-ps'; box.hidden = true; box.setAttribute('role', 'listbox');
    box.id = 'zbm-ps-' + Math.random().toString(36).slice(2, 8);
    input.setAttribute('aria-controls', box.id);
    host.appendChild(box);
    var timer = 0, seq = 0, active = -1;
    function close() { box.hidden = true; active = -1; input.setAttribute('aria-expanded', 'false'); }
    function run() {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      var my = ++seq;
      fetchSuggest(q).then(function (res) { if (my !== seq || !res) return; render(box, q, res); active = -1; input.setAttribute('aria-expanded', 'true'); })
        .catch(function () {});
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 180); });
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2) run(); });
    input.addEventListener('keydown', function (e) {
      var items = box.hidden ? [] : Array.prototype.slice.call(box.querySelectorAll('[data-ps-item]'));
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!items.length) return;
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items.forEach(function (el, i) { el.classList.toggle('is-active', i === active); });
        items[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active >= 0 && items[active]) {
        e.preventDefault(); location.href = items[active].href;
      } else if (e.key === 'Escape') { close(); }
    });
    document.addEventListener('click', function (e) { if (e.target !== input && !box.contains(e.target)) close(); });
  }

  // header "Search" -> search bar under the header
  function headerBar() {
    var link = document.querySelector('a.zbm-hdr-search');
    var header = document.querySelector('[data-zbm-header]');
    if (!link || !header) return;
    var bar = null;
    function build() {
      bar = document.createElement('div');
      bar.className = 'zbm-psbar'; bar.hidden = true;
      bar.innerHTML = '<form class="zbm-psbar-in" action="' + root + 'search" method="get" role="search">' +
        '<input type="search" name="q" placeholder="Search a color number, brand or product" aria-label="Search">' +
        '<button type="submit" class="zbm-psbar-go">Search</button><button type="button" class="zbm-psbar-x">Close</button></form>';
      if (getComputedStyle(header).position === 'static') header.style.position = 'relative';
      header.appendChild(bar);
      attach(bar.querySelector('input'));
      bar.querySelector('.zbm-psbar-x').addEventListener('click', hide);
      bar.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !bar.querySelector('.zbm-ps:not([hidden])')) hide(); });
    }
    function show() { if (!bar) build(); bar.hidden = false; link.setAttribute('aria-expanded', 'true'); var i = bar.querySelector('input'); i.focus(); }
    function hide() { if (bar) bar.hidden = true; link.setAttribute('aria-expanded', 'false'); link.focus(); }
    link.setAttribute('aria-expanded', 'false');
    link.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      if (/\/search/.test(location.pathname)) { var si = document.querySelector('main input[name="q"], [data-zbm-q]'); if (si) { e.preventDefault(); si.focus(); return; } }
      e.preventDefault();
      if (bar && !bar.hidden) hide(); else show();
    });
  }

  function init() {
    headerBar();
    Array.prototype.forEach.call(document.querySelectorAll('form[action$="/search"] input[name="q"], [data-zbm-q]'), function (i) {
      if (!i.closest('.zbm-psbar')) attach(i);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
